/// <reference types="google.accounts" />

import { lazy, Router } from 'retend/router'
import Index from '@/pages'

const metadata = {
   viewport:
      'width=device-width, initial-scale=1.0, user-scalable=no, viewport-fit=cover, interactive-widget=resizes-visual',
   themeColor: '#272727',
   manifest: '/manifest.json'
}

export const createRouter = () => {
   return new Router({
      stackMode: true,
      routes: [
         {
            path: '/',
            component: Index,
            redirect: '/waiting-list',
            metadata,
            children: [
               {
                  path: 'styleguide',
                  subtree: lazy(() => import('@/pages/styleguide/styleguide.routes'))
               },
               {
                  path: 'waiting-list',
                  subtree: lazy(() => import('@/pages/waiting-list/waiting-list.routes'))
               },
               {
                  path: 'app',
                  subtree: lazy(() => import('@/pages/app/app.routes'))
               }
            ]
         }
      ]
   })
}
